export default "__VITE_ASSET__$PfpX4_N__"